import { Injectable } from '@angular/core';

import { Configurations } from 'src/app/app.configurations';
import { config } from 'src/app/environment-config';

@Injectable()
export class ConfigurationService {
  constructor(private configurations: Configurations) {
    this.configurations.appConfiguration.hbAPI = `//${window.location.host}/`;
  }

  load(): Promise<any> {
    return new Promise((resolve) => {
      const envConfiguration = config();
      this.configurations.appConfiguration.gbmAPI = envConfiguration.api;
      this.configurations.appConfiguration.userPreferencesApi =
        envConfiguration.user_preferences_api;
      this.configurations.appConfiguration.applicationId =
        envConfiguration.app as any;
      this.configurations.appConfiguration.solace = {
        url: envConfiguration.solace_endPoint,
        vpnName: envConfiguration.solace_vpnName,
        userName: envConfiguration.solace_userName,
        password: envConfiguration.solace_code,
        topicSplitter: envConfiguration.solace_topicSplitter,
        connectRetryCount: envConfiguration.solace_connectRetryCount,
        subscriptionTimeout: envConfiguration.solace_subscriptionTimeout,
        subscriptionRetryCount: envConfiguration.solace_subscriptionRetryCount,
        subscriptionRetryInterval:
          envConfiguration.solace_subscriptionRetryInterval,
      };
      this.configurations.appConfiguration.timeOuts = {
        timeOut30Seg: envConfiguration.timeOuts_timeOut30Seg,
        timeOut1Min: envConfiguration.timeOuts_timeOut1Min,
        timeOut2Min: envConfiguration.timeOuts_timeOut2Min,
        timeOut5Min: envConfiguration.timeOuts_timeOut5Min,
        timeOut10Min: envConfiguration.timeOuts_timeOut10Min,
      };
      this.configurations.appConfiguration.reports = {
        tokenDomain: envConfiguration.t_report_tokenDomain,
        url: envConfiguration.t_report_url,
        newUrl: envConfiguration.new_t_report_url,
        urlComparador: envConfiguration.comparador_url,
        key: envConfiguration.t_report_key,
        token: envConfiguration.t_report_token,
      };
      this.configurations.appConfiguration.deviceId = 1;

      resolve(envConfiguration);
    });
  }
}
